// Warns when a primary image (e.g. a thumbnail/preview) is missing or fails to
// load and we fall back to rendering an alternative image source instead.
// console.warn is intercepted by BugsnagService (src/config/bugsnag.ts) and reported
// as a "ConsoleWarning" event with severity "warning", so these fallbacks are trackable in Bugsnag.

type ImageFallbackReason =
  | 'missing-primary'
  | 'broken-primary'
  | 'failed-to-load-primary-and-fallback';

const reasonText: Record<ImageFallbackReason, string> = {
  'missing-primary': 'the primary image source is missing',
  'broken-primary': 'the primary image failed to load',
  'failed-to-load-primary-and-fallback': 'the primary image and the fallback image failed to load after retries'
};

const alreadyWarned = new Set<string>();

export function warnImageFallback(
  reason: ImageFallbackReason,
  details: { context: string, primaryUrl?: string | null, fallbackUrl?: string | null }
) {
  // warn only once per image per session to avoid flooding Bugsnag on re-renders/retries
  const dedupeKey = `${reason}|${details.context}|${details.primaryUrl}|${details.fallbackUrl}`;
  if (alreadyWarned.has(dedupeKey)) {
    return;
  }
  alreadyWarned.add(dedupeKey);

  console.warn(
    `[ImageFallback] Falling back to the alternative image source: ${reasonText[reason]}.`,
    details
  );
}
